import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy">
      <h1>Privacy Policy for Ammu Arts</h1>
      <p>Last updated: December 31 2024</p>

      <h2>1. Introduction</h2>
      <p>Welcome to Ammu Arts! We value your privacy and are committed to protecting your personal information. This privacy policy explains how we collect, use, and protect your data.</p>

      <h2>2. Information Collection</h2>
      <p>We collect personal information such as your name, email, address, and payment details when you place an order or create an account.</p>

      <h2>3. How We Use Your Information</h2>
      <p>Your information is used for order processing, communication, and improving our services. We do not sell your personal information to third parties.</p>

      <h2>4. Data Security</h2>
      <p>We implement industry-standard security measures to protect your personal information from unauthorized access or disclosure.</p>

      <h2>5. Your Rights</h2>
      <p>You have the right to access, correct, or delete your personal data. If you wish to exercise any of these rights, please contact us.</p>

      <h2>6. Third Parties</h2>
      <p>We may share your information with trusted third-party service providers, such as payment processors, but they are prohibited from using your data for their own purposes.</p>

      <h2>7. Cookies</h2>
      <p>We use cookies to improve your experience on our site. You can manage your cookie preferences through your browser settings.</p>

      <h2>8. Changes to This Policy</h2>
      <p>We may update this policy from time to time. Any changes will be posted on this page with the updated date.</p>

      <h2>9. Contact Us</h2>
      <p>If you have any questions or concerns about our privacy policy, please contact us at ammucraftarts@gmail.com.</p>

      <footer>
        <p>© 2024 Ammu Arts. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default PrivacyPolicy;
